import _ from 'lodash';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { getRightAsMiddlePanelProps, getRightPanelProps } from './utils';
import { PANEL_CONFIGURATIONS } from '../../../constants/PanelLayoutConstants';
import { useFormSelector } from '../../../custom-hooks';
import { FORM_KEYS } from '../../../form-designer/constants/form-manager.constants';
import { getContainerWidthPercentBasedOnSelectedSubGrids } from '../../../form-designer/selectors/runtime.selectors';
import { getUITA } from '../../../utils/commonUtils';
import CustomGridPanel from '../CustomGridPanel/CustomGridPanel';

function RightPanel({
  children,
  config,
  setConfig,
  hideButtons,
  isTaskStatusPanelEnabled,
  isMiddlePanelEnabled,
  isRightPanelMounted,
  isMobileDevice,
  invertedPanel,
  ...otherProps
}) {
  const { pathname } = useLocation();

  const isHideScroll = otherProps?.panelProps?.isHideScroll;
  const panelProps = invertedPanel
    ? getRightAsMiddlePanelProps({ config, setConfig, otherProps })
    : getRightPanelProps({ config, setConfig, otherProps, isMiddlePanelEnabled });

  const widthPercent = useFormSelector(getContainerWidthPercentBasedOnSelectedSubGrids, {
    pathname,
    formKey: FORM_KEYS.DETAIL,
    defaultWidthPercent: panelProps.widthPercent,
  });

  panelProps.widthPercent = widthPercent;

  const isRightPanelOpened =
    config === PANEL_CONFIGURATIONS.MIDDLE_COLLAPSED || config === PANEL_CONFIGURATIONS.ONLY_RIGHT;

  const customHideButtons =
    config === PANEL_CONFIGURATIONS.ONLY_RIGHT
      ? !isMiddlePanelEnabled && !isTaskStatusPanelEnabled
      : null;

  return (
    isRightPanelMounted && (
      <CustomGridPanel
        {...otherProps}
        {...panelProps}
        widthPercent={isMobileDevice ? (isRightPanelOpened ? 100 : 0) : panelProps.widthPercent}
        hideButtons={!_.isNil(customHideButtons) ? customHideButtons : hideButtons}
        bgColor="#fff"
        testAutomation={getUITA('DetailFormPanel')}
        isHideScroll={isHideScroll}
      >
        {children}
      </CustomGridPanel>
    )
  );
}

export default RightPanel;
